let isFetching = false;
let infiniteScrollObserver = null;

const initLiveFilter = () => {
    const hasLiveFilter = document.body.classList.contains('ns-live-filter-enabled');
    const hasInfiniteScroll = document.body.classList.contains('ns-infinite-scroll-enabled');

    // Only initialize if either live filter or infinite scroll is enabled
    if (!hasLiveFilter && !hasInfiniteScroll) {
        return;
    }

    // Event listener for all ajax-bound links
    document.addEventListener('click', (e) => {
        if (!document.body.classList.contains('ns-live-filter-enabled')) return;

        const link = e.target.closest('a');
        if (!link) return;

        if (!shouldProcessLink(link)) return;

        e.preventDefault();
        const url = link.href;
        loadArchivePage(url);
    });

    // Helper to build the correct search parameters and action URL for form submissions
    const getFormSubmitUrl = (form) => {
        const formData = new FormData(form);
        const formParams = new URLSearchParams(formData);

        // For search forms, start fresh; otherwise, merge with existing URL query params
        const isSearch = form.classList.contains('woocommerce-product-search') || form.querySelector('input[name="s"]');
        let currentParams;
        if (isSearch) {
            currentParams = new URLSearchParams();
        } else {
            currentParams = new URLSearchParams(window.location.search);
        }

        // Merge form parameters into current parameters
        for (const [key, value] of formParams.entries()) {
            if (value) {
                currentParams.set(key, value);
            } else {
                currentParams.delete(key);
            }
        }

        // Reset pagination to page 1 on new filter submissions (except catalog sorting)
        if (!form.classList.contains('woocommerce-ordering')) {
            currentParams.delete('paged');
        }

        // Retrieve clean form action URL
        const actionAttr = form.getAttribute('action') || window.location.href;
        const actionUrl = new URL(actionAttr, window.location.href);

        // Return path with merged parameters
        return actionUrl.pathname + '?' + currentParams.toString();
    };

    // Event listener for filter form submissions and select changes
    if (window.jQuery) {
        window.jQuery(document).on('submit', '.shop-archive-sidebar form, form.woocommerce-ordering', function(e) {
            if (!document.body.classList.contains('ns-live-filter-enabled')) return;
            e.preventDefault();
            const url = getFormSubmitUrl(this);
            loadArchivePage(url);
        });

        window.jQuery(document).on('change', '.shop-archive-sidebar select, form.woocommerce-ordering select', function(e) {
            if (!document.body.classList.contains('ns-live-filter-enabled')) return;
            const form = this.closest('form');
            if (form) {
                e.preventDefault();
                const url = getFormSubmitUrl(form);
                loadArchivePage(url);
            } else if (this.value && (this.value.startsWith('http://') || this.value.startsWith('https://') || (this.value.startsWith('/') && !this.value.startsWith('//')))) {
                e.preventDefault();
                loadArchivePage(this.value);
            }
        });
    } else {
        document.addEventListener('submit', (e) => {
            if (!document.body.classList.contains('ns-live-filter-enabled')) return;
            const form = e.target;
            const isSidebarForm = form.closest('.shop-archive-sidebar');
            const isOrderingForm = form.classList.contains('woocommerce-ordering') || form.closest('form.woocommerce-ordering');

            if (!isSidebarForm && !isOrderingForm) return;

            e.preventDefault();
            const url = getFormSubmitUrl(form);
            loadArchivePage(url);
        });
    }

    // Intercept change event on orderby dropdown or radio buttons directly
    document.addEventListener('change', (e) => {
        if (!document.body.classList.contains('ns-live-filter-enabled')) return;
        const orderbyElement = e.target.closest('form.woocommerce-ordering [name="orderby"]');
        if (orderbyElement) {
            e.preventDefault();
            const form = orderbyElement.closest('form.woocommerce-ordering');
            const url = getFormSubmitUrl(form);
            loadArchivePage(url);
        }
    });

    // Event listener for filter stock switch widget
    document.addEventListener('change', (e) => {
        if (!document.body.classList.contains('ns-live-filter-enabled')) return;
        const switchCheckbox = e.target.closest('#archive-in-stock-switch');
        if (switchCheckbox) {
            e.preventDefault();
            const currentUrl = new URL(window.location.href);
            const params = currentUrl.searchParams;

            if (switchCheckbox.checked) {
                params.set('stock', 'instock');
            } else {
                params.delete('stock');
            }

            // Reset pagination to page 1 on new filter submissions
            params.delete('paged');

            const newUrl = currentUrl.pathname + '?' + params.toString();
            loadArchivePage(newUrl);
        }
    });

    // Handle browser back/forward history navigation
    window.addEventListener('popstate', () => {
        loadArchivePage(window.location.href);
    });

    // Initialize infinite scroll observer setup if active
    setupInfiniteScroll();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLiveFilter);
} else {
    initLiveFilter();
}

/**
 * Checks if the anchor element should be handled via Ajax.
 */
function shouldProcessLink(link) {
    if (!document.body.classList.contains('ns-live-filter-enabled')) {
        return false;
    }

    if (!link.href || link.href.startsWith('#') || link.href.startsWith('javascript:')) {
        return false;
    }

    // Must be same origin
    if (new URL(link.href).origin !== window.location.origin) {
        return false;
    }

    // Do not live load product categories at all (reload normally)
    if (link.closest('ul.product-categories')) {
        return false;
    }

    // Must be inside sidebar, pagination, ordering header, active filters, or have clear filters class
    if (link.closest('.shop-archive-sidebar') ||
        link.closest('.woocommerce-pagination') ||
        link.closest('.products-archive-header') ||
        link.closest('.products-archive-active-filters') ||
        link.classList.contains('clear-shop-filters') ||
        link.closest('.woocommerce-widget-layered-nav') ||
        link.closest('.widget_rating_filter') ||
        link.closest('.widget_price_filter')
    ) {
        return true;
    }

    return false;
}

/**
 * Setup and bind infinite scroll functionality.
 */
function setupInfiniteScroll() {
    if (!document.body.classList.contains('ns-infinite-scroll-enabled')) {
        return;
    }

    if (typeof IntersectionObserver === 'undefined') {
        return;
    }

    const paginationEl = document.querySelector('.woocommerce-pagination');
    const productsContainer = document.querySelector('#archive-ajax-container .products');

    if (!productsContainer) {
        return;
    }

    // Hide standard pagination since infinite scroll handles item loads
    if (paginationEl) {
        paginationEl.style.display = 'none';
    }

    // Disconnect previous observer
    if (infiniteScrollObserver) {
        infiniteScrollObserver.disconnect();
        infiniteScrollObserver = null;
    }

    // Verify next page link exists
    const nextLinkEl = document.querySelector('.woocommerce-pagination a.next');
    if (!nextLinkEl || !nextLinkEl.href) {
        const oldSentinel = document.getElementById('ns-infinite-scroll-sentinel');
        if (oldSentinel) {
            oldSentinel.remove();
        }
        return;
    }

    // Create sentinel if needed
    let sentinel = document.getElementById('ns-infinite-scroll-sentinel');
    if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.id = 'ns-infinite-scroll-sentinel';
        sentinel.className = 'ns-infinite-scroll-sentinel text-center my-4 w-100';
        sentinel.innerHTML = `
            <div class="spinner-border text-primary d-none" role="status" style="width: 2rem; height: 2rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;
    }

    // Place sentinel below products list container
    productsContainer.after(sentinel);

    // Initialize IntersectionObserver
    infiniteScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isFetching) {
                const currentNextLink = document.querySelector('.woocommerce-pagination a.next');
                if (currentNextLink && currentNextLink.href) {
                    loadArchivePage(currentNextLink.href, true);
                }
            }
        });
    }, {
        rootMargin: '200px'
    });

    infiniteScrollObserver.observe(sentinel);
}

/**
 * Handles WooCommerce ordering form submission via Ajax.
 */
function submitOrderingForm(form) {
    const formData = new FormData(form);

    // Merge existing filter query parameters so we don't lose filters
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams(formData);

    for (const [key, value] of newParams.entries()) {
        currentParams.set(key, value);
    }

    const action = form.getAttribute('action') || window.location.pathname;
    const url = action + '?' + currentParams.toString();

    loadArchivePage(url);
}

/**
 * Performs Ajax request to load product archive page content.
 */
function loadArchivePage(url, appendItems = false) {
    if (isFetching) return;
    isFetching = true;

    if (appendItems) {
        const sentinel = document.getElementById('ns-infinite-scroll-sentinel');
        if (sentinel) {
            const spinner = sentinel.querySelector('.spinner-border');
            if (spinner) {
                spinner.classList.remove('d-none');
            }
        }
    } else {
        showLoading();
    }

    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response not ok');
            }
            return response.text();
        })
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            if (appendItems) {
                // Append products items
                const newProducts = doc.querySelectorAll('#archive-ajax-container .products > *');
                const currentProductsContainer = document.querySelector('#archive-ajax-container .products');
                if (newProducts.length > 0 && currentProductsContainer) {
                    newProducts.forEach(el => currentProductsContainer.appendChild(el));
                }

                // Update pagination elements
                const paginationSelector = '.woocommerce-pagination';
                const newPagination = doc.querySelector(paginationSelector);
                const currentPagination = document.querySelector(paginationSelector);
                if (currentPagination) {
                    if (newPagination) {
                        currentPagination.innerHTML = newPagination.innerHTML;
                    } else {
                        currentPagination.remove();
                    }
                } else if (newPagination) {
                    const archiveAjaxContainer = document.querySelector('#archive-ajax-container');
                    if (archiveAjaxContainer) {
                        const div = document.createElement('div');
                        div.innerHTML = newPagination.outerHTML;
                        archiveAjaxContainer.appendChild(div.firstElementChild);
                    }
                }

                // Update result count elements
                const newResultCounts = doc.querySelectorAll('.woocommerce-result-count');
                const currentResultCounts = document.querySelectorAll('.woocommerce-result-count');
                if (newResultCounts.length > 0 && currentResultCounts.length > 0) {
                    currentResultCounts.forEach((el, index) => {
                        const newEl = newResultCounts[index] || newResultCounts[0];
                        el.innerHTML = newEl.innerHTML;
                    });
                }
            } else {
                // Clean up offcanvas states, backdrops, and body scroll locks
                cleanupOffcanvasAndBackdrops();

                // Destroy select2 instances on elements before replacing DOM
                destroySelect2Instances();

                // Update the main archive/ajax container
                const containerSelector = '#archive-ajax-container';
                const newContainer = doc.querySelector(containerSelector);
                const currentContainer = document.querySelector(containerSelector);

                if (newContainer && currentContainer) {
                    cleanSelect2Attributes(newContainer);
                    currentContainer.innerHTML = newContainer.innerHTML;
                }

                // Update browser URL and history state
                history.pushState({ url: url }, '', url);
            }

            // Update the sidebar if it exists (only on non-append full reload filters)
            if (!appendItems) {
                const sidebarSelector = '.shop-archive-sidebar';
                const newSidebars = doc.querySelectorAll(sidebarSelector);
                const currentSidebars = document.querySelectorAll(sidebarSelector);

                if (newSidebars.length > 0 && currentSidebars.length > 0) {
                    currentSidebars.forEach((sidebar, index) => {
                        const newSidebar = newSidebars[index] || newSidebars[0];
                        cleanSelect2Attributes(newSidebar);
                        sidebar.innerHTML = newSidebar.innerHTML;
                    });
                }
            }

            // Re-initialize theme scripts and active components
            reinitializeThemeScripts();

            // Re-setup infinite scroll observer
            setupInfiniteScroll();

            // Smooth scroll back to top of container on filter reloads
            if (!appendItems) {
                const scrollTarget = document.querySelector('#archive-ajax-container');
                if (scrollTarget) {
                    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        })
        .catch(error => {
            console.error('Ajax live filter failed, redirecting:', error);
            if (appendItems) {
                const sentinel = document.getElementById('ns-infinite-scroll-sentinel');
                if (sentinel) {
                    const spinner = sentinel.querySelector('.spinner-border');
                    if (spinner) {
                        spinner.classList.add('d-none');
                    }
                }
            } else {
                window.location.href = url;
            }
        })
        .finally(() => {
            isFetching = false;
            if (!appendItems) {
                hideLoading();
            } else {
                const sentinel = document.getElementById('ns-infinite-scroll-sentinel');
                if (sentinel) {
                    const spinner = sentinel.querySelector('.spinner-border');
                    if (spinner) {
                        spinner.classList.add('d-none');
                    }
                }
            }
        });
}

/**
 * Show loading overlays on dynamic containers.
 */
function showLoading() {
    const container = document.querySelector('#archive-ajax-container');
    const sidebars = document.querySelectorAll('.shop-archive-sidebar');

    if (container) container.classList.add('ajax-loading');
    sidebars.forEach(sidebar => sidebar.classList.add('ajax-loading'));
}

/**
 * Hide loading overlays.
 */
function hideLoading() {
    const container = document.querySelector('#archive-ajax-container');
    const sidebars = document.querySelectorAll('.shop-archive-sidebar');

    if (container) container.classList.remove('ajax-loading');
    sidebars.forEach(sidebar => sidebar.classList.remove('ajax-loading'));
}

/**
 * Re-initializes custom elements and event bindings after Ajax DOM replacement.
 */
function reinitializeThemeScripts() {
    // 1. Re-initialize lazy image loader
    document.querySelectorAll('img.lazy').forEach(img => {
        img.addEventListener('load', function () {
            const figure = img.closest('figure.thumb');
            if (figure) figure.style.backgroundImage = 'none';
        });
        if (img.complete) {
            img.dispatchEvent(new Event('load'));
        }
    });

    // 2. Re-initialize WooCommerce price slider trigger
    if (window.jQuery) {
        window.jQuery(document.body).trigger('init_price_filter');
    }

    // 3. Re-initialize sidebar accordion widgets collapse state
    const sidebars = document.querySelectorAll('.shop-archive-sidebar');
    sidebars.forEach(sidebar => {
        if (sidebar && sidebar.classList.contains('shop-archive-sidebar--collapsed')) {
            const widgets = sidebar.querySelectorAll('.sidebar-widget');

            const hasActiveFilter = (widget) => {
                if (widget.querySelector('.chosen, .active, .current-cat, .current-cat-parent, .woocommerce-widget-layered-nav-list__item--chosen')) {
                    return true;
                }
                const checkedInputs = widget.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
                if (checkedInputs.length > 0) {
                    return true;
                }
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.toString() !== "") {
                    if (widget.classList.contains('widget_price_filter') || widget.querySelector('.price_slider')) {
                        if (urlParams.has('min_price') || urlParams.has('max_price')) {
                            return true;
                        }
                    }
                    const inputs = widget.querySelectorAll('input, select');
                    for (let input of inputs) {
                        const name = input.getAttribute('name');
                        if (name && urlParams.has(name)) {
                            const val = urlParams.get(name);
                            if (val !== null && val !== '') {
                                return true;
                            }
                        }
                    }
                }
                return false;
            };

            let firstHeaderWidget = null;
            let activeFilterFound = false;

            widgets.forEach(widget => {
                widget.classList.remove('show', 'collapsed');

                if (widget.querySelector('.widget-header')) {
                    if (!firstHeaderWidget) {
                        firstHeaderWidget = widget;
                    }

                    if (hasActiveFilter(widget)) {
                        widget.classList.add('show');
                        activeFilterFound = true;
                    } else {
                        widget.classList.add('collapsed');
                    }
                }
            });

            if (!activeFilterFound && firstHeaderWidget) {
                firstHeaderWidget.classList.remove('collapsed');
                firstHeaderWidget.classList.add('show');
            }
        }
    });

    // 4. Re-initialize and update Sticky Sidebar
    const stickySidebarEl = document.querySelector('.shop-archive-sidebar-sticky-wrapper');
    if (stickySidebarEl && typeof window.StickySidebar !== 'undefined') {
        try {
            if (window.stickySidebarInstance) {
                window.stickySidebarInstance.destroy();
            }
            window.stickySidebarInstance = new window.StickySidebar('.shop-archive-sidebar-sticky-wrapper', {
                topSpacing: 30,
                bottomSpacing: 30,
                minWidth: 992
            });
            window.stickySidebarInstance.updateSticky();
            window.dispatchEvent(new Event('resize'));
        } catch (e) {
            console.error('StickySidebar re-initialization failed:', e);
        }
    }

    // 5. Re-initialize product cart boxes (quantities/add-to-cart triggers)
    document.querySelectorAll('.product-cart-box').forEach(el => {
        el.dispatchEvent(new CustomEvent('init', { bubbles: true }));
    });

    // 6. Re-initialize any carousels/swipers inside the new content
    document.querySelectorAll('.swiper[data-settings]').forEach(el => {
        el.dispatchEvent(new CustomEvent('init_carousel', { bubbles: true }));
    });

    // 7. Re-initialize select2 / selectWoo filter dropdowns
    reinitializeSelect2Filters();
}

/**
 * Cleans up open Bootstrap offcanvas and modals, removes lock classes and backdrop elements.
 */
function cleanupOffcanvasAndBackdrops() {
    // 1. Hide Bootstrap offcanvas if open
    if (window.bootstrap && window.bootstrap.Offcanvas) {
        document.querySelectorAll('.offcanvas.show').forEach(el => {
            try {
                const instance = window.bootstrap.Offcanvas.getInstance(el) || new window.bootstrap.Offcanvas(el);
                if (instance) {
                    instance.hide();
                }
            } catch (e) {
                console.error('Error hiding Bootstrap offcanvas:', e);
            }
        });
    }

    // 2. Hide Bootstrap modal if open
    if (window.bootstrap && window.bootstrap.Modal) {
        document.querySelectorAll('.modal.show').forEach(el => {
            try {
                const instance = window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el);
                if (instance) {
                    instance.hide();
                }
            } catch (e) {
                console.error('Error hiding Bootstrap modal:', e);
            }
        });
    }

    // 3. Remove all backdrop elements
    document.querySelectorAll('.offcanvas-backdrop, .modal-backdrop, .fade.show').forEach(backdrop => {
        if (backdrop.classList.contains('offcanvas-backdrop') || backdrop.classList.contains('modal-backdrop')) {
            backdrop.remove();
        }
    });

    // 4. Remove active/show classes on theme sidebar
    document.querySelectorAll('.shop-archive-sidebar').forEach(sidebar => {
        sidebar.classList.remove('show');
    });

    // 5. Unlock body and html scrolling
    document.body.classList.remove('modal-open', 'offcanvas-open', 'mobile-panel-showing');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    const htmlEl = document.documentElement;
    if (htmlEl) {
        htmlEl.style.overflow = '';
        htmlEl.style.paddingRight = '';
    }
}

/**
 * Destroys existing select2 / selectWoo instances before DOM elements are replaced.
 */
function destroySelect2Instances() {
    if (window.jQuery && (window.jQuery.fn.select2 || window.jQuery.fn.selectWoo)) {
        window.jQuery('.shop-archive-sidebar select, #archive-ajax-container select, form.woocommerce-ordering select').each(function () {
            const $select = window.jQuery(this);
            if ($select.hasClass('select2-hidden-accessible') || $select.data('select2')) {
                try {
                    $select.select2('destroy');
                } catch (e) {
                    // Ignore errors during destruction
                }
            }
        });
    }
}

/**
 * Cleans select2 attributes and leftover nodes from newly fetched HTML containers.
 */
function cleanSelect2Attributes(container) {
    if (!container) return;
    const selects = container.querySelectorAll('select');
    selects.forEach(select => {
        select.classList.remove('select2-hidden-accessible');
        select.removeAttribute('data-select2-id');
        select.removeAttribute('aria-hidden');
        if (select.getAttribute('tabindex') === '-1') {
            select.removeAttribute('tabindex');
        }
        if (select.style.display === 'none') {
            select.style.display = '';
        }
    });
    container.querySelectorAll('.select2-container').forEach(el => el.remove());
}

/**
 * Re-initializes select2 / selectWoo dropdown filters after Ajax replacement.
 */
function reinitializeSelect2Filters() {
    if (!window.jQuery) return;

    // Trigger WooCommerce native enhanced select init events
    window.jQuery(document.body).trigger('wc-enhanced-select-init');
    window.jQuery(document.body).trigger('enhanced-select-init');

    // Re-initialize select2/selectWoo on filter selects if available
    if (window.jQuery.fn.select2 || window.jQuery.fn.selectWoo) {
        const targetSelects = window.jQuery('.shop-archive-sidebar select, #archive-ajax-container select, form.woocommerce-ordering select');

        targetSelects.each(function () {
            const $select = window.jQuery(this);
            if (!$select.data('select2') && !$select.hasClass('select2-hidden-accessible')) {
                const isFilterSelect = $select.hasClass('select2') ||
                    $select.hasClass('wc-enhanced-select') ||
                    $select.hasClass('enhanced') ||
                    $select.closest('.widget_layered_nav').length > 0 ||
                    $select.closest('.widget_rating_filter').length > 0 ||
                    $select.closest('.woocommerce-ordering').length > 0 ||
                    $select.closest('.shop-archive-sidebar').length > 0;

                if (isFilterSelect) {
                    try {
                        $select.select2({
                            dir: document.documentElement.getAttribute('dir') || 'rtl',
                            width: '100%',
                            minimumResultsForSearch: 10
                        });
                    } catch (e) {
                        console.error('Error re-initializing select2 filter:', e);
                    }
                }
            }
        });
    }
}
